import request from '../../../common/request/index.js'
const api = request.api

export default {
  page: (params) => {
    return api.post('gun/gun/page', params)
  },
  list: (params) => {
    return api.post('gun/gun/list', params)
  },
  get: (id) => {
    return api.get(`gun/gun/${id}`)
  },
  create: (data) => {
    return api.post('gun/gun', data)
  },
  update: (data) => {
    return api.put('gun/gun', data)
  },
  delete: (id) => {
    return api.delete(`gun/gun/${id}`)
  },
  // ===== 新增：定时改价相关 =====
  schedulePrice: (data) => {
    return api.post('gun/gun/schedulePrice', data)
  },
  getScheduleList: (params) => {
    return api.get(`gun/gun/scheduleList`, { gunId: params.gunId });
  },
  cancelSchedule: (data) => {
    return api.post('gun/gun/cancelSchedule', data)
  },
  // ===== 新增导出方法 =====
  export: (params) => {
    return api.post('gun/gun/export', params, { responseType: 'blob' })
  }
}